module.exports = __webpack_public_path__ + "img/logo.639b5efe.png";